__webpack_require__.p = "/momentuum/";